import { motion } from "framer-motion";
import * as LucideIcons from "lucide-react";
import { PROBLEMS } from "@/lib/constants";

export default function Problems() {
  return (
    <section className="bg-[#F5F7FA] py-24" data-testid="problems-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Diagnostic</div>
          <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-[#0B1F3A] tracking-tight text-balance">
            Votre entreprise perd-elle des clients <span className="text-[#00B8D9]">sans le savoir</span> ?
          </h2>
          <p className="mt-4 text-[#4B5563] text-lg">
            Voici les 8 problèmes les plus fréquents qui freinent la croissance des PME au Québec.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PROBLEMS.map((p, i) => {
            const Icon = LucideIcons[p.icon] || LucideIcons.AlertCircle;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`problem-card-${i}`}
                className="group bg-white border border-gray-200 rounded-xl p-6 hover:border-[#00B8D9] hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              >
                <div className="h-10 w-10 rounded-lg bg-[#00B8D9]/10 group-hover:bg-[#00B8D9] flex items-center justify-center mb-4 transition-colors">
                  <Icon className="h-5 w-5 text-[#00B8D9] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-heading font-bold text-[#0B1F3A] text-base leading-snug">{p.title}</h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
